module.exports = "<vb-generic-selection-input\r\n  inputId=\"product-packing-input\"\r\n  label=\"Verpackung\"\r\n  [items]=\"productPackings\"\r\n  [selectedItem]=\"item\"\r\n  [control]=\"control\"\r\n  (itemSelected)=\"onProductPackingSelected($event)\">\r\n</vb-generic-selection-input>"


//////////////////
// WEBPACK FOOTER
// ./src/app/store-management/product/product-packing-selection/product-packing-selection.component.html
// module id = ./src/app/store-management/product/product-packing-selection/product-packing-selection.component.html
// module chunks = main